import { render } from "./ChangePass.vue?vue&type=template&id=24eae955&scoped=true"
import script from "./ChangePass.vue?vue&type=script&lang=js"
export * from "./ChangePass.vue?vue&type=script&lang=js"

import "./ChangePass.vue?vue&type=style&index=0&id=24eae955&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24eae955"]])

export default __exports__